// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___1qTtu","image":"image___2newN","buttonWrapper":"buttonWrapper___Rnf8w"};